import { FormValidations} from "features/shared/forms/hooks/useForm";
import PatternValidatonRule from "features/validation/rules/PatternValidatonRule";

export const reservedCapacityGasFormValidations = (): FormValidations => {
  return {
    DESC_TMSMLOUVAID: {
      required: true,
      type: "OnlyRequired"
    },
    DESC_TMKAPACITAPLYNTYP: {
      required: true,
      type: "OnlyRequired"
    },
    DESC_TMKAPACITAPLYNOD: {
      required: true,
      type: "OnlyRequired"
    },
    DESC_TMKAPACITAPLYNDO: {
      required: true,
      type: "OnlyRequired"
    },
    DESC_TMKAPACITAPLYNPOZADOVANAKAPACITA: {
      required: true,
      type: "Pattern",
      regex: /^\d+$/,
      message: "invalidInteger"
    } as PatternValidatonRule
  };
}